export const formatBookingPropertyAddress = (address) => (
  <span>
    {address.street}
    {address.street ? <br /> : null}
    {address.city}
    {address.city ? <br /> : null}
    {address.county}
    {address.county ? <br /> : null}
    {address.postcode}
  </span>
);

export const addressHelpers = {
  formatBookingPropertyAddress,
};
